var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#1B5C29",
    fillOpacity: 0.08
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 38,
    height: 38,
    rx: 19,
    stroke: "#1B5C29",
    strokeOpacity: 0.08,
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0001 24C17.83 24 15.0109 25.5306 13.2161 27.906C12.8298 28.4172 12.6367 28.6728 12.643 29.0183C12.6479 29.2852 12.8155 29.6219 13.0255 29.7867C13.2973 30 13.674 30 14.4273 30H27.5729C28.3262 30 28.7029 30 28.9747 29.7867C29.1847 29.6219 29.3523 29.2852 29.3572 29.0183C29.3635 28.6728 29.1704 28.4172 28.7841 27.906C26.9893 25.5306 24.1702 24 21.0001 24Z",
    stroke: "#1B5C29",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0001 21C23.4854 21 25.5001 18.9853 25.5001 16.5C25.5001 14.0147 23.4854 12 21.0001 12C18.5148 12 16.5001 14.0147 16.5001 16.5C16.5001 18.9853 18.5148 21 21.0001 21Z",
    stroke: "#1B5C29",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.8c85ca55694be4962659fd4008c9f26e.svg";
export { ForwardRef as ReactComponent };